import axios from '@/components/api/axios';

// let res = axios.axiosPost('/api/auth/login');
// console.log(res);
async function login() {
  // 0063342
  // 0063377
  // 2731275 // 誕生日
  // 2762546
  // 2709128
  // 2759896 // クーポン
  // 2757726
  // 2685127
  // 2760615 // BCが複数登録されているかつクーポン使用可能
  // 2759904 // BCが複数登録されているかつ誕生月割引
  // 0217031 // note テスト用

  const data = {
    // memberId: '2865379', // availableBulkSettingがfalseのID
    //memberId: '2700315', // availableBulkSettingがtrueのID
    memberId: '1205929', // 2025年おみくじキャンペーン用
    password: '1111111',
  }
  const res = await axios.axiosLogin('/api/auth/login', data).then((a) => {
    console.log(a);
    return a;
  }).catch((err) => {
    console.log(err);
  });
  // console.log(res);
  // if(res != undefined) {
    localStorage.setItem('accessToken', res.token.accessToken);
    localStorage.setItem('refreshToken', res.token.refreshToken);
  // }

  // return res;
}

async function refresh() {
  const data = {
    refreshToken: localStorage.getItem('refreshToken')
  };
  try {
    const res = await axios.axiosLogin('/api/auth/refresh', data);
    localStorage.setItem('accessToken', res.accessToken);
    localStorage.setItem('refreshToken', res.refreshToken);
    return true;
  } catch (e) {
    return false;
  }

}

async function ssoWeb(redirectUrl) {
  const data = {
    clientId: '441b2f6a-e432-49f1-814a-afdcbe0cc45a',
    redirectUrl: redirectUrl
  };
  try {
    const res = await axios.axiosPost('/api/auth/ssoWeb', data);
    return res
  } catch (e) {
    console.log(e);
  }
}

async function getToken(codes) {
  const data = {
    clientId: 'f27b4d91-cd8a-478d-89cc-c4542cf6fefc',
    code: codes
  };
  const res = await axios.axiosLogin('/api/auth/token', data);
  if(res) {
    console.log('ok');
    localStorage.setItem('accessToken', res.accessToken);
    localStorage.setItem('refreshToken', res.refreshToken);
    return true;
  } else {
    console.log('ng');
    return false;
  }
}

export default {
  login,
  refresh,
  ssoWeb,
  getToken
}



// WEBPACK FOOTER //
// ./src/components/api/auth.js